export default "__VITE_ASSET__CwklDYCn__"